<template>
  <div style="padding: 18px">
    <v-card>
      <v-toolbar height="0px;" flat>
        <template v-slot:extension>
          <v-tabs color="orange" v-model="tabs" center-active>
            <v-tab class="tablist" @change="onclickOne()">Merchant List</v-tab>
            <v-tab class="tablist" @change="onclickTwo()"
              >Merchant Transaction</v-tab
            >
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <v-card class="card" style="height: 50%">
            <div style="width: 100%">
              <v-row>
                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="search.merchant_type"
                    :items="merchantType"
                    label="Tipe Merchant"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="search.qr_type"
                    :items="listQrType"
                    label="Jenis QR"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="search.settlement_type"
                    :items="settlementTypeItems"
                    label="Settlement Type"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="search.merchant_criteria"
                    :items="listMerchantCriteria"
                    label="Skala Usaha"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-col cols="12" sm="3" md="3" v-bind="attrs" v-on="on">
                      <v-dialog
                        ref="rangeDateDialog"
                        v-model="rangeDateDialog"
                        :return-value.sync="search.created_at"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            id="rangeDate"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            v-model="dateRangeText"
                            label="Select Date"
                            hide-details="true"
                            dense
                          />
                        </template>

                        <v-date-picker
                          v-model="search.created_at"
                          scrollable
                          range
                          :max="getTommorowDate(0)"
                        >
                          <v-spacer />
                          <v-btn
                            text
                            color="primary"
                            @click="rangeDateDialog = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              () => {
                                checkRangeDate();
                                $refs.rangeDateDialog.save(search.created_at);
                              }
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </template>
                  <span
                    v-text="
                      dateRangeText == '' ? 'not selected' : dateRangeText
                    "
                  />
                </v-tooltip>

                <v-col cols="12">
                  <v-btn
                    class="ma-1"
                    small
                    color="warning"
                    @click.stop="showData"
                  >
                    <v-icon left> mdi-magnify </v-icon>
                    search
                  </v-btn>
                  <v-btn class="ma-1" small @click="clearMerchant">
                    Reset
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card>

          <div class="container" v-if="loadingCount">
            <div class="card-container">
              <v-card class="card-loader">
                <div class="card-content">
                  <div class="grey-text mb-2">
                    <v-skeleton-loader type="article" />
                  </div>
                </div>
              </v-card>

              <v-card class="card-loader">
                <div class="card-content">
                  <div class="grey-text mb-2">
                    <v-skeleton-loader type="article" />
                  </div>
                </div>
              </v-card>
            </div>
          </div>

          <div class="card-container" v-else>
            <v-card class="card">
              <div class="card-content">
                <div class="merchant">Jumlah Merchant</div>

                <div class="totmerchant">{{ countMerchant }}</div>
              </div>
            </v-card>

            <v-card class="card">
              <div class="card-content">
                <div class="aggregator">Jumlah Aggregator</div>

                <div class="totagregator">{{ countAggregator }}</div>
              </div>
            </v-card>
          </div>

          <div class="card-container">
            <v-card class="card h-fit-content flex-column text-center">
              <div class="grafikmerchant">Grafik Merchant Bulanan</div>
              <template>
                <div>
                  <v-col cols="6" sm="2">
                    <v-select
                      v-model="yearMerchant"
                      :items="listYear1"
                      label="Tahun"
                      item-text="text"
                      item-value="value"
                      @change="getGrafikMerchant(yearMerchant)"
                      clearable
                      hide-details="true"
                      dense
                    />
                    <br />
                  </v-col>
                </div>
              </template>

              <div class="card-container" v-if="loadinglist">
                <v-card class="card-loader-grafik">
                  <div class="card-content">
                    <div class="grey-text mb-2">
                      <v-skeleton-loader type="article" />
                    </div>
                  </div>
                </v-card>
              </div>

              <chart-merchant
                v-else
                :chartData="dataMerchant"
                :options="chartOptions"
                :chart-id="'transaction-chart'"
                :height="200"
              />
            </v-card>
          </div>

          <div class="card-container">
            <v-card class="card h-fit-content flex-column text-center">
              <div class="grafikmerchant">Grafik Aggregator Bulanan</div>
              <br />

              <div class="card-container" v-if="loadinglist">
                <v-card class="card-loader-grafik">
                  <div class="card-content">
                    <div class="grey-text mb-2">
                      <v-skeleton-loader type="article" />
                    </div>
                  </div>
                </v-card>
              </div>

              <chart-agregator
                v-else
                :chartData="dataAggregator"
                :options="chartOptions"
                :chart-id="'transaction-chart'"
                :height="200"
              />
            </v-card>
          </div>
        </v-tab-item>

        <v-tab-item>
          <v-card class="card" style="height: 50%">
            <div style="width: 100%">
              <v-row>
                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="searchtrans.merchant_typetrans"
                    :items="merchantTypeTrans"
                    label="Tipe Merchant"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="searchtrans.merchant_criteriatrans"
                    :items="listMerchantCriteriaTrans"
                    label="Skala Usaha"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="searchtrans.settlement_typetrans"
                    :items="settlementTypeItemsTrans"
                    label="Settlement Type"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="searchtrans.qr_typetrans"
                    :items="listQrType"
                    label="Jenis QR"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="searchtrans.payment_type"
                    :items="paymentType"
                    label="Jenis Transaksi"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="searchtrans.status_trans"
                    :items="statusTrans"
                    label="Status Transaksi"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="searchtrans.sof_trans"
                    :items="sofTrans"
                    label="Source of Fund"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                  <v-select
                    v-model="searchtrans.settlement_status_trans"
                    :items="settlementStatusTrans"
                    label="Settlement Status"
                    item-text="text"
                    item-value="value"
                    clearable
                    hide-details="true"
                    dense
                  />
                </v-col>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-col cols="12" sm="3" md="3" v-bind="attrs" v-on="on">
                      <v-dialog
                        ref="rangeDateDialogTrans"
                        v-model="rangeDateDialogTrans"
                        :return-value.sync="searchtrans.created_attrans"
                        persistent
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            id="rangeDate"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            v-model="dateRangeTextTrans"
                            label="Select Date"
                            hide-details="true"
                            dense
                          />
                        </template>

                        <v-date-picker
                          v-model="searchtrans.created_attrans"
                          scrollable
                          range
                          :max="getTommorowDate(0)"
                        >
                          <v-spacer />
                          <v-btn
                            text
                            color="primary"
                            @click="rangeDateDialogTrans = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              () => {
                                checkRangeDateTrans();
                                $refs.rangeDateDialogTrans.save(
                                  searchtrans.created_attrans
                                );
                              }
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </template>
                  <span
                    v-text="
                      dateRangeTextTrans == ''
                        ? 'not selected'
                        : dateRangeTextTrans
                    "
                  />
                </v-tooltip>

                <v-col cols="12">
                  <v-btn
                    class="ma-1"
                    small
                    color="warning"
                    @click.stop="showDataTrans"
                  >
                    <v-icon left> mdi-magnify </v-icon>
                    search
                  </v-btn>
                  <v-btn class="ma-1" small @click="clearMerchantTrans">
                    Reset
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card>

          <div class="container" v-if="loadingTrans">
            <div class="card-container">
              <v-card class="card-loader">
                <div class="card-content">
                  <div class="grey-text mb-2">
                    <v-skeleton-loader type="article" />
                  </div>
                </div>
              </v-card>

              <v-card class="card-loader">
                <div class="card-content">
                  <div class="grey-text mb-2">
                    <v-skeleton-loader type="article" />
                  </div>
                </div>
              </v-card>
            </div>
          </div>

          <div class="card-container" v-else>
            <v-card class="card">
              <div class="card-content">
                <div class="merchant">Jumlah Transaksi</div>
                <div v-if="loadinglist">
                  <v-row class="fill-height" justify="center" />
                </div>
                <div class="totmerchant" v-else>{{ countTransaction }}</div>
              </div>
            </v-card>

            <v-card class="card">
              <div class="card-content">
                <div class="aggregator">Sales Volume</div>
                <div v-if="loadinglist">
                  <v-row class="fill-height" justify="center" />
                </div>
                <div class="totagregator" v-else>{{ countSalesVolume }}</div>
              </div>
            </v-card>
          </div>

          <div class="card-container">
            <v-card class="card h-fit-content flex-column text-center">
              <div class="grafikmerchant">Grafik Transaksi Bulanan</div>
              <template>
                <div>
                  <v-col cols="4" sm="2">
                    <v-select
                      v-model="yearTransaction"
                      :items="listYear2"
                      label="Tahun"
                      item-text="text"
                      item-value="value"
                      @change="getGrafikTransaction(yearTransaction)"
                      clearable
                      hide-details="true"
                      dense
                    /><br />
                  </v-col>
                </div>
              </template>

              <div class="card-container" v-if="loadingGrafik">
                <v-card class="card-loader-grafik">
                  <div class="card-content">
                    <div class="grey-text mb-2">
                      <v-skeleton-loader type="article" />
                    </div>
                  </div>
                </v-card>
              </div>

              <chart-transaction
                v-else
                :chartData="dataTransaction"
                :options="chartOptionsTrans"
                :chart-id="'transaction-chart'"
                :height="200"
              />
            </v-card>
          </div>

          <div class="card-container">
            <v-card class="card h-fit-content flex-column text-center">
              <div class="grafikmerchant">Grafik Sales Volum Bulanan</div>
              <br />

              <div class="card-container" v-if="loadingGrafik">
                <v-card class="card-loader-grafik">
                  <div class="card-content">
                    <div class="grey-text mb-2">
                      <v-skeleton-loader type="article" />
                    </div>
                  </div>
                </v-card>
              </div>

              <chart-sales
                v-else
                :chartData="dataSalesVolume"
                :options="chartOptionsSales"
                :chart-id="'sales-chart'"
                :height="200"
              />
            </v-card>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import {
  getListYear,
  dataListMerchantCriteria,
  dataQrType,
  dataSettlementTypeItems,
  dataTipeMerchantOnboarding,
  dataListTrxReportStatus,
  sof,
  dataListSettlementStatus,
  dataGetPaymentType,
} from '../../store/params';

import { isEmpty, date, showAlert, getTommorowDate } from '../../lib/helpers';

export default {
  components: {
    ChartMerchant: () => import('../../components/ChartMerchant'),
    ChartAgregator: () => import('../../components/ChartAgregator'),
    ChartTransaction: () => import('../../components/ChartTransaction'),
    ChartSales: () => import('../../components/ChartSales'),
  },
  data: () => ({
    yearMerchant: String(new Date().getFullYear()),
    yearTransaction: String(new Date().getFullYear()),
    rangeDateDialog: false,
    rangeDateDialogTrans: false,
    tabs: null,
    year: '',
    loadinglist: false,
    loadingCount: false,
    loadingTrans: false,
    loadingGrafik: false,
    listYear1: getListYear,
    listYear2: getListYear,
    dataMerchant: {},
    dataAggregator: {},
    dataTransaction: {},
    dataSalesVolume: {},
    chartOptions: {},
    chartOptionsTrans: {},
    chartOptionsSales: {},
    countMerchant: null,
    countAggregator: null,
    countTransaction: null,
    countSalesVolume: null,
    mounthName: '',
    total: '',
    getGarfik: false,

    search: {
      qr_type: '',
      merchant_type: '',
      settlement_type: '',
      merchant_criteria: '',
      created_at: [],
    },

    searchtrans: {
      merchant_typetrans: '',
      merchant_criteriatrans: '',
      qr_typetrans: '',
      created_attrans: [],
      status_trans: '',
      sof_trans: '',
      settlement_typetrans: '',
      settlement_status_trans: '',
      payment_type: '',
    },

    listMerchantCriteria: dataListMerchantCriteria,
    listQrType: dataQrType,
    settlementTypeItems: dataSettlementTypeItems,
    merchantType: dataTipeMerchantOnboarding,

    merchantTypeTrans: dataTipeMerchantOnboarding,
    listMerchantCriteriaTrans: dataListMerchantCriteria,
    statusTrans: dataListTrxReportStatus,
    sofTrans: sof,
    settlementTypeItemsTrans: dataSettlementTypeItems,
    settlementStatusTrans: dataListSettlementStatus,
    paymentType: dataGetPaymentType,
  }),

  computed: {
    dateRangeText() {
      return this.search.created_at.join(' ~ ');
    },

    dateRangeTextTrans() {
      return this.searchtrans.created_attrans.join(' ~ ');
    },

    dataGrafikMerchant() {
      return this.$store.state.dashboardDetail.grafikMerchant;
    },

    dataGrafikAggregator() {
      return this.$store.state.dashboardDetail.grafikAggregator;
    },

    dataGrafikTransaction() {
      return this.$store.state.dashboardDetail.grafikTransaction;
    },

    dataGrafikSalesVolume() {
      return this.$store.state.dashboardDetail.grafikSalesVolume;
    },

    allowMerchant() {
      return (
        isEmpty(this.search.qr_type) &&
        isEmpty(this.search.merchant_type) &&
        isEmpty(this.search.settlement_type) &&
        isEmpty(this.search.merchant_criteria) &&
        this.search.created_at.length < 1
      );
    },

    allowTransaction() {
      return (
        isEmpty(this.searchtrans.merchant_typetrans) &&
        isEmpty(this.searchtrans.merchant_criteriatrans) &&
        isEmpty(this.searchtrans.qr_typetrans) &&
        isEmpty(this.searchtrans.status_trans) &&
        isEmpty(this.searchtrans.sof_trans) &&
        isEmpty(this.searchtrans.settlement_typetrans) &&
        isEmpty(this.searchtrans.settlement_status_trans) &&
        this.searchtrans.created_attrans.length < 1
      );
    },
  },

  // mounted() {},

  created() {
    this.getCountMerchant();
    this.getCountAggregator();
  },
  methods: {
    clearFilter() {
      this.search.qr_type = '';
      this.search.merchant_type = '';
      this.search.settlement_type = '';
      this.search.merchant_criteria = '';
      this.search.created_at = [];
    },

    clearFilterTrans() {
      this.searchtrans.merchant_typetrans = '';
      this.searchtrans.merchant_criteriatrans = '';
      this.searchtrans.qr_typetrans = '';
      this.searchtrans.created_attrans = [];
      this.searchtrans.status_trans = '';
      this.searchtrans.sof_trans = '';
      this.searchtrans.settlement_typetrans = '';
      this.searchtrans.settlement_status_trans = '';
      this.searchtrans.payment_type = '';
    },

    clearMerchant() {
      this.clearFilter();
      this.getCountMerchantClear();
      this.getCountAggregator();
    },

    clearMerchantTrans() {
      this.clearFilterTrans();
      this.getCountTransactionClear();
      this.getCountSalesVolume();
    },

    onclickOne() {
      this.clearFilter();
      this.getCountMerchant();
      this.getCountAggregator();
    },

    onclickTwo() {
      this.getCountTransaction();
      this.getCountSalesVolume();
      this.getGrafikTransactionLoad();
      this.getGrafikSalesVolumeLoad();
    },

    checkRangeDate() {
      if (this.search.created_at.length == 1) {
        this.search.created_at.push(this.search.created_at[0]);
      }
    },

    checkRangeDateTrans() {
      if (this.searchtrans.created_attrans.length == 1) {
        this.searchtrans.created_attrans.push(
          this.searchtrans.created_attrans[0]
        );
      }
    },

    async getCountMerchant() {
      this.loadingCount = true;
      this.loadinglist = true;
      this.search.created_at.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountMerchant', {
          date,
          search: this.search,
        })
        .then((merchant) => {
          this.countMerchant = merchant;
        })
        .finally(() => {
          this.yearMerchant = String(new Date().getFullYear());
          this.getGrafikMerchantLoad();
          this.getGrafikAggregatorLoad();
          this.loadingCount = false;
          this.loadinglist = false;
        });
    },

    async getCountMerchantClear() {
      this.loadingCount = true;
      this.search.created_at.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountMerchant', {
          date,
          search: this.search,
        })
        .then((merchant) => {
          this.countMerchant = merchant;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    async getCountAggregator() {
      this.loadingCount = true;
      this.search.created_at.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountAggregator', {
          date,
          search: this.search,
        })
        .then((aggregator) => {
          this.countAggregator = aggregator;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    showData() {
      this.search = { ...this.search };
      const result = this.getValDate(this.search.created_at);
      if (result > 30) {
        showAlert(
          this.$store,
          'Range date must be <= 31 days',
          'mdi-alert',
          'red'
        );
        return false;
      }
      this.getDataList();
      return true;
    },

    getDataList() {
      this.getCountMerchantFilter();
      this.getCountAggregatorFilter();
    },

    getValDate(dateVal) {
      const date1 = new Date(dateVal[0]);
      const date2 = new Date(dateVal[1]);
      const diffTime = Math.abs(date2 - date1);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },

    async getCountMerchantFilter() {
      this.loadingCount = true;
      this.search.created_at.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountMerchant', {
          date,
          search: this.search,
        })
        .then((merchant) => {
          this.countMerchant = merchant;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    async getCountAggregatorFilter() {
      this.loadingCount = true;
      this.search.created_at.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountAggregator', {
          date,
          search: this.search,
        })
        .then((aggregator) => {
          this.countAggregator = aggregator;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    async getGrafikMerchantLoad() {
      this.loadingCount = true;
      await this.$store
        .dispatch('dashboardDetail/getGrafikMerchant', { year: '', date })
        .then(() => {
          const dataLebel = this.dataGrafikMerchant;
          const datamonth = [];
          const dataTotal = [];
          dataLebel.map((item) => {
            datamonth.push(item.month_name);
            dataTotal.push(item.total);
          });

          this.dataMerchant = {
            labels: datamonth,
            datasets: [
              {
                label: 'Jumlah Merchant',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotal,
              },
            ],
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.loadingCount = false;
        });
    },

    async getGrafikAggregatorLoad() {
      this.loadinglist = true;
      await this.$store
        .dispatch('dashboardDetail/getGrafikAggregator', { getyear: '', date })
        .then(() => {
          const dataLebel = this.dataGrafikAggregator;
          const dataMonth = [];
          const dataTotal = [];
          dataLebel.map((item) => {
            dataMonth.push(item.month_name);
            dataTotal.push(item.total);
          });

          this.dataAggregator = {
            labels: dataMonth,
            datasets: [
              {
                label: 'Jumlah Aggregator',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotal,
              },
            ],
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.loadinglist = false;
        });
    },

    async getGrafikMerchant(year) {
      this.loadinglist = true;
      await this.$store
        .dispatch('dashboardDetail/getGrafikMerchant', { year, date })
        .then(() => {
          const dataLebel = this.dataGrafikMerchant;
          const datamonth = [];
          const dataTotal = [];
          dataLebel.map((item) => {
            datamonth.push(item.month_name);
            dataTotal.push(item.total);
          });

          this.dataMerchant = {
            labels: datamonth,
            datasets: [
              {
                label: 'Jumlah Merchant',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotal,
              },
            ],
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.loadinglist = false;
          this.getGrafikAggregator(year);
        });
    },

    async getGrafikAggregator(year) {
      this.loadinglist = true;
      await this.$store
        .dispatch('dashboardDetail/getGrafikAggregator', { year, date })
        .then(() => {
          const dataLebel = this.dataGrafikAggregator;
          const dataMonth = [];
          const dataTotal = [];
          dataLebel.map((item) => {
            dataMonth.push(item.month_name);
            dataTotal.push(item.total);
          });

          this.dataAggregator = {
            labels: dataMonth,
            datasets: [
              {
                label: 'Jumlah Aggregator',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotal,
              },
            ],
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.loadinglist = false;
        });
    },

    // transaction
    async getCountTransaction() {
      this.loadingGrafik = true;
      this.loadingTrans = true;
      this.searchtrans.created_attrans.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountTransaction', {
          date,
          searchtrans: this.searchtrans,
        })
        .then((transaction) => {
          this.countTransaction = transaction;
        })
        .finally(() => {
          this.yearTransaction = String(new Date().getFullYear());
          this.loadingGrafik = false;
          this.loadingTrans = false;
        });
    },

    async getCountTransactionClear() {
      this.loadingTrans = true;
      this.searchtrans.created_attrans.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountTransaction', {
          date,
          searchtrans: this.searchtrans,
        })
        .then((transaction) => {
          this.countTransaction = transaction;
        })
        .finally(() => {
          this.loadingTrans = false;
        });
    },

    async getCountSalesVolume() {
      this.loadingTrans = true;
      this.searchtrans.created_attrans.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountSalesVolum', {
          date,
          searchtrans: this.searchtrans,
        })
        .then((salesVolume) => {
          this.countSalesVolume = salesVolume;
        })
        .finally(() => {
          this.loadingTrans = false;
        });
    },

    showDataTrans() {
      this.searchtrans = { ...this.searchtrans };
      const result = this.getValDate(this.searchtrans.created_attrans);
      if (result > 30) {
        showAlert(
          this.$store,
          'Range date must be <= 31 days',
          'mdi-alert',
          'red'
        );
        return false;
      }
      this.getDataListTrans();
      return true;
    },

    getDataListTrans() {
      this.getCountTransactionFilter();
      this.getCountSalesVolumeFilter();
    },

    async getCountTransactionFilter() {
      this.loadingTrans = true;
      this.searchtrans.created_attrans.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountTransaction', {
          date,
          searchtrans: this.searchtrans,
        })
        .then((transaction) => {
          this.countTransaction = transaction;
        })
        .finally(() => {
          this.loadingTrans = false;
        });
    },

    async getCountSalesVolumeFilter() {
      this.loadingTrans = true;
      this.searchtrans.created_attrans.sort();
      await this.$store
        .dispatch('dashboardDetail/getCountSalesVolum', {
          date,
          searchtrans: this.searchtrans,
        })
        .then((salesVolume) => {
          this.countSalesVolume = salesVolume;
        })
        .finally(() => {
          this.loadingTrans = false;
        });
    },

    async getGrafikTransactionLoad() {
      this.loadingGrafik = true;
      await this.$store
        .dispatch('dashboardDetail/getGrafikTransaction', { year: '', date })
        .then(() => {
          const dataLebel = this.dataGrafikTransaction;
          const datamonth = [];
          const dataTotal = [];
          dataLebel.map((item) => {
            datamonth.push(item.month_name);
            dataTotal.push(item.total);
          });

          this.dataTransaction = {
            labels: datamonth,
            datasets: [
              {
                label: 'Jumlah Transaction',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotal,
              },
            ],
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.loadingGrafik = false;
        });
    },

    async getGrafikSalesVolumeLoad() {
      this.loadingGrafik = true;
      await this.$store
        .dispatch('dashboardDetail/getGrafikSalesVolume', { year: '', date })
        .then(() => {
          const dataLebelSales = this.dataGrafikSalesVolume;
          const datamonthsales = [];
          const dataTotalSales = [];
          dataLebelSales.map((item) => {
            datamonthsales.push(item.month_name);
            dataTotalSales.push(item.total);
          });

          this.dataSalesVolume = {
            labels: datamonthsales,
            datasets: [
              {
                label: 'Jumlah Sales Volume',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotalSales,
              },
            ],
          };

          this.chartOptionsSales = {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    callback: (value) =>
                      new Intl.NumberFormat('de-DE').format(value), // numeral(value).format('0.0,[00]'),
                  },
                },
              ],
            },

            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  const { label } = data.datasets[tooltipItem.datasetIndex];
                  const value = new Intl.NumberFormat('de-DE').format(
                    tooltipItem.yLabel
                  );
                  return `${label}: Rp ${value}`;
                },
              },
            },
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.loadingGrafik = false;
        });
    },

    async getGrafikTransaction(year) {
      this.loadingGrafik = true;
      await this.$store
        .dispatch('dashboardDetail/getGrafikTransaction', { year, date })
        .then(() => {
          const dataLebel = this.dataGrafikTransaction;
          const datamonth = [];
          const dataTotal = [];
          dataLebel.map((item) => {
            datamonth.push(item.month_name);
            dataTotal.push(item.total);
          });

          this.dataTransaction = {
            labels: datamonth,
            datasets: [
              {
                label: 'Jumlah Transaction',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotal,
              },
            ],
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.getGrafikSalesVolume(year);
          this.loadingGrafik = false;
        });
    },

    async getGrafikSalesVolume(year) {
      this.loadingGrafik = true;
      await this.$store
        .dispatch('dashboardDetail/getGrafikSalesVolume', { year, date })
        .then(() => {
          const dataLebelSales = this.dataGrafikSalesVolume;
          const datamonthsales = [];
          const dataTotalSales = [];
          dataLebelSales.map((item) => {
            datamonthsales.push(item.month_name);
            dataTotalSales.push(item.total);
          });

          this.dataSalesVolume = {
            labels: datamonthsales,
            datasets: [
              {
                label: 'Jumlah Sales Volume',
                backgroundColor: '#e36013',
                fill: false,
                borderColor: '#e36013',
                data: dataTotalSales,
              },
            ],
          };

          this.chartOptionsSales = {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    callback: (value) =>
                      new Intl.NumberFormat('de-DE').format(value), // numeral(value).format('0.0,[00]'),
                  },
                },
              ],
            },

            tooltips: {
              callbacks: {
                label(tooltipItem, data) {
                  const { label } = data.datasets[tooltipItem.datasetIndex];
                  const value = new Intl.NumberFormat('de-DE').format(
                    tooltipItem.yLabel
                  );
                  return `${label}: Rp ${value}`;
                },
              },
            },
          };

          this.getGarfik = true;
        })
        .finally(() => {
          this.loadingGrafik = false;
        });
    },
    getTommorowDate,
  },
};
</script>

<style scoped>
.v-tab {
  text-transform: none !important;
  font-family: sans-serif;
  font-weight: 400;
}

.card-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.card-loader {
  display: flex;
  flex: 1;
  height: 140px;
  margin: 15px;
  min-width: 250px;
  padding: 25px;
}

.card {
  display: flex;
  flex: 1;
  height: 140px;
  margin: 15px;
  min-width: 250px;
  padding: 25px;
}

.h-fit-content {
  height: fit-content;
}

.card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.aggregator {
  text-align: center;
  font-size: 18px;
  color: orangered;
  font-weight: 500;
}

.totagregator {
  text-align: center;
  font-size: 25px;
  font-weight: 500;
  color: #146b84;
}

.merchant {
  text-align: center;
  font-size: 18px;
  color: orangered;
  font-weight: 500;
}

.totmerchant {
  text-align: center;
  font-size: 25px;
  font-weight: 500;
  color: #146b84;
}

.grafikmerchant {
  text-align: left;
  font-size: 18px;
  color: orangered;
  font-weight: 400;
}

.card-loader-grafik {
  display: flex;
  flex: 1;
  height: 300px;
  margin: 15px;
  min-width: 250px;
  padding: 25px;
}

.tablist {
  color: orangered;
  font-weight: 540;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
}
</style>
